import { Button } from 'components/elements/buttons';
import { useFormState } from 'components/elements/form';
import { SeparatorVertical } from 'components/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import FlightSection from './flight-card';
import { TourListFormType } from '../form-type';
import { onAddNewFlight } from '../hooks/use-get-default-values';

export default function FlightTable() {
  const { t } = useTranslation();
  const { getValues, trigger, setValue } = useFormContext<TourListFormType>();
  const name = 'tourFlights' as const;

  const onAdd = React.useCallback(() => {
    const tourFlights = getValues(name);
    setValue(name, [...tourFlights, onAddNewFlight()]);
    trigger(name);
  }, [getValues, setValue, trigger]);

  const onRemove = React.useCallback(
    (index: number) => {
      const tourFlights = getValues(name);
      tourFlights.splice(index, 1);
      setValue(name, tourFlights);
      trigger(name);
    },
    [getValues, setValue, trigger],
  );

  const tourFlights = getValues(name);
  const { editable } = useFormState();

  return (
    <div>
      {tourFlights.map((field, idx) => (
        <React.Fragment key={field.customId}>
          <FlightSection
            parentIndex={idx}
            onRemove={() => onRemove(idx)}
            fieldLength={tourFlights.length}
          />
          <SeparatorVertical $margin={20}>
            <div style={{ height: 1, width: 4 }} />
          </SeparatorVertical>
        </React.Fragment>
      ))}
      {editable && (
        <Button buttonType="secondary" onClick={onAdd}>
          {t('common:add_extra', { extra: t('ticketOrders:schedule') })}
        </Button>
      )}
    </div>
  );
}
